export const NON_BREAKING_SPACE = '\u00a0';
export const SPACE = ' ';
export const DASH = '-';
export const DOT = '·';
export const APPROXIMATION = '~';
export const NUMBER_SIGN = '№';
export const ACCOUNT_ID = 'AID';
export const VACANCY_ID = 'ID';
export const PLUS_SIGN = '+';
export const MINUS_SIGN = '−';

export enum SortType {
    ASC = 'asc',
    DESC = 'desc',
}

export const MODAL_ONE_LINE_ITEMS_COUNT = 20;

export const HHCDN_HOST = 'https://hhcdn.ru';
export const UXFB_WIDGET_SRC = `${HHCDN_HOST}/uxfeedback/widget.html`;
export const HHDISK_HOST = 'https://disk.hh.ru';
export const HH_RU_PURCHASE_URL = 'https://hh.ru/employer/invoice/purchase';

export const TABS_CONTAINER_CORRECTIONS = {
    correctionXS: 16,
    correctionS: 56,
};
